export const mode = import.meta.env.MODE;
export const api_base_url = import.meta.env.VITE_API_BASE_URL;
export const partner_center_url = import.meta.env.VITE_PARTNER_CENTER_URL;
export const sentry_dsn = import.meta.env.VITE_SENTRY_DSN;
